import React, { memo, useCallback } from "react";

import WatchlistMenuItemView from "./WatchlistMenuItemView";

import { WatchlistWatchlistMetaFragment } from "@/generated/graphql";

/**
 * Props for WatchlistMenuItemContainer component
 */
export interface WatchlistMenuItemContainerProps {
  readonly watchlist: WatchlistWatchlistMetaFragment;
  readonly isSelected: boolean;
  readonly isFirst: boolean;
  readonly widthName: number;
  readonly onPress: (id: string) => void;
}

/**
 * Container component for individual watchlist menu item
 * Handles press callback transformation from watchlist ID
 * @param root0 - Component props
 * @param root0.watchlist - Watchlist data fragment
 * @param root0.isSelected - Whether this item is currently selected
 * @param root0.isFirst - Whether this is the first item
 * @param root0.widthName - Window width for responsive styling
 * @param root0.onPress - Callback invoked with watchlist ID when pressed
 */
const WatchlistMenuItemContainer = memo(
  ({
    watchlist,
    isSelected,
    isFirst,
    widthName,
    onPress,
  }: WatchlistMenuItemContainerProps) => {
    const handlePress = useCallback(() => {
      onPress(watchlist.id);
    }, [onPress, watchlist.id]);

    return (
      <WatchlistMenuItemView
        name={watchlist.name}
        isSelected={isSelected}
        isFirst={isFirst}
        widthName={widthName}
        onPress={handlePress}
      />
    );
  }
);

WatchlistMenuItemContainer.displayName = "WatchlistMenuItemContainer";

export default WatchlistMenuItemContainer;
